import React from 'react';
import "./pages.css";

const Education = () => {
  return (
    <div className="center-container">
      <ul className='ul-list'>
        <li className='education-item'>
          <div className='education-title'>Ph.D. in Computer Science and Engineering</div>
          <div className='education-details'>The Pennsylvania State University, 2021- Present</div>
        </li>
        <li className='education-item'>
          <div className='education-title'>B.Sc. in Computer Science and Engineering</div>
          <div className='education-details'>Bangladesh University of Engineering and Technology (BUET), 2018</div>
        </li>
      </ul>
    </div>
  );
};

export default Education;